import React from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import { Container, AppBar, Toolbar, Typography, Button, Box, Paper } from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
import AddEditSeries from "./../../AddEditSeries/AddEditSeries";

const SeriesAddEditPage = () => {
  const location = useLocation();
  const { id } = useParams();
  const isEdit = location.pathname.indexOf('edit') > -1;
  const seriesRef = React.useRef();

  const handleSave = (e) => {
    e.preventDefault();
    seriesRef.current?.submit();
  };

  return (
    <Container sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? 'Edit Series' : 'Create New Series'}
          </Typography>
          <Button
            color="error"
            component={Link}
            to="/series"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditSeries ref={seriesRef} isEdit={isEdit} selectedId={id} />
        </Paper>
      </Box>
    </Container>
  );
};

export default SeriesAddEditPage;
